<ion-app>
  <ion-menu
    contentId="main-content"
    menuId="main-menu"
    side="start"
    [swipeGesture]="false"
  >
    <ion-icon
      name="close-outline"
      class="mb-lg ml-md mt-xl close-menu-icon"
      (click)="closeMenu()"
      aria-label="Close menu"
      size="large"
      color="dark"
    ></ion-icon>
    <app-menu (itemClicked)="closeMenu()" />
  </ion-menu>
  <ion-router-outlet id="main-content" [animated]="false"></ion-router-outlet>
</ion-app>

<!-- FIXME: ion-select inside ion-modal are not displayed until a ion-select is present outside of ion-modal -->
<ion-item style="display: none">
  <ion-select label="debug">
    <ion-select-option value="null">null</ion-select-option>
  </ion-select>
</ion-item>

<ion-toast
  [isOpen]="alertService.getMessage() !== ''"
  message="{{ alertService.getMessage() }}"
  [class]="getAlertClass()"
  position="top"
  (didDismiss)="alertService.hide()"
></ion-toast>
